<template>
  <div class="extents-panel">
    <div class="extents-label">EXTENT</div>
    <div class="extents-row">
      <div
        v-for="extent in extents"
        :key="extent.id"
        class="extent-card"
        :class="{ 'extent-card--active': extent.extent_description === selectedExtent }"
        @click="extent.extent_description !== selectedExtent && changeExtent(extent)"
      >
        <img :src="getExtentImg(extent.extent_description)" class="extent-img" />
        <span class="extent-name">{{ extent.extent_description }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.extents-panel {
  padding: 0.5rem 0.625rem 0.625rem;
  min-width: 12.5rem;
}

.extents-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.extents-row {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0.3125rem;
  overflow: visible;
  max-height: none;
}

.extent-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.3125rem 0.4375rem;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
  flex-shrink: 0;
}

.extent-card:hover:not(.extent-card--active) {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.25);
}

.extent-card--active {
  background: rgba(0, 123, 255, 0.25);
  border-color: #007bff;
  cursor: default;
}

.extent-img {
  width: 3rem;
  height: 2.125rem;
  object-fit: contain;
  border-radius: 3px;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.06);
}

.extent-name {
  text-align: left;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.75rem;
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
  line-height: 1.25;
  user-select: none;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'Generic_CollapsedExtents',
  props: ['map', 'selectedExtent', 'userOrg'],
  data() {
    return {
      extents: [],
      EuropeSVG: require('../../../assets/extents/Europe.svg'),
      JapanSVG: require('../../../assets/extents/Japan.svg'),
      MiddleEastSVG: require('../../../assets/extents/MiddleEast.svg'),
      NorthAmericaSVG: require('../../../assets/extents/NorthAmerica.svg'),
      SouthKoreaSVG: require('../../../assets/extents/SouthKorea.svg')
    }
  },
  methods: {
    changeExtent(extent) {
      this.$emit('extentChanged', extent)
    },
    getExtents() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/getExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              company_id: this.userOrg
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getExtents API Call Error: ' + content.errors)
            } else {
              this.extents = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getExtentImg(extent) {
      let extentImg
      switch (extent) {
        case 'Europe':
          extentImg = this.EuropeSVG
          break
        case 'Japan':
          extentImg = this.JapanSVG
          break
        case 'Middle East':
          extentImg = this.MiddleEastSVG
          break
        case 'Kuwait':
          extentImg = this.MiddleEastSVG
          break
        case 'South Korea':
          extentImg = this.SouthKoreaSVG
          break
        case 'Saudi Arabia':
          extentImg = this.MiddleEastSVG
          break
        case 'North America':
        default:
          extentImg = this.NorthAmericaSVG
          break
      }
      return extentImg
    }
  },
  mounted() {
    if (this.userOrg) {
      this.getExtents()
    }
  },
  watch: {
    userOrg: function () {
      this.getExtents()
    }
  }
}
</script>
